import type { IEntityModel } from './base'
import type { IGarminDevice } from './garmin_device'
import type { IJitaiTaskConfig } from './jitai_task_config'
import type { IMethod } from './method'
import type { IProject } from './project'
import type { IQuestionnaire } from './questionnaire'
import type { IStopwatchGarminStream } from './stopwatch_garmin_stream'
import type { IStopwatchMovesenseStream } from './stopwatch_movesense_stream'
import type { ITaskEventTracker } from './task_event_tracker'
import type { ITaskSchedule } from './task_schedule'
import type { ITaskSet } from './task_set'
import type { ITimer } from './timer'
import type { ITodo } from './todo'
import type { IWorkspace } from './workspace'

export enum TaskType {
  Todo = 'todo',
  Timer = 'timer',
  TaskSet = 'task_set',
  GarminDevice = 'garmin_device',
  Questionnaire = 'questionnaire',
  StopwatchGarminStream = 'stopwatch_garmin_stream',
  StopwatchMovesenseStream = 'stopwatch_movesense_stream',
  StopwatchMovesenseLogData = 'stopwatch_movesense_log_data',
}

export type MovesenseTaskType =
  | TaskType.StopwatchMovesenseStream
  | TaskType.StopwatchMovesenseLogData

export enum ReminderType {
  Date = 'date',
  Cron = 'cron',
}
export interface ReminderItem {
  type: ReminderType
  value: string
}

export interface ITask extends IEntityModel {
  index?: number
  enabled?: boolean
  reminderList: ReminderItem[]
  color?: string | null
  required: boolean
  scheduleRepeat?: boolean | null
  scheduleDescription?: string | null

  workspaceId: string
  workspace?: IWorkspace
  projectId: string
  project?: IProject
  methodId: string
  method?: IMethod

  type: TaskType

  todo?: ITodo
  timer?: ITimer
  stopwatchGarminStream?: IStopwatchGarminStream
  taskSet?: ITaskSet
  questionnaire?: IQuestionnaire
  garminDevice?: IGarminDevice
  taskSetParentId?: string
  taskSetParent?: ITaskSet
  stopwatchMovesenseStream?: IStopwatchMovesenseStream
  scheduleList?: ITaskSchedule[]
  eventTracker?: ITaskEventTracker
  jitaiTaskConfigList?: IJitaiTaskConfig[]
}
